import React, { useEffect, useState } from "react";
import "../../../styles/desktop/dispositivo.css";

import fetchDispositivos from "../../../API/getDispositivos";

export default function Dispositivos() {
    const [dispositivos, setDispositivos] = useState([]);

    useEffect(() => {
        const getData = async () => {
            const data = await fetchDispositivos();
            setDispositivos(data);
        };
        getData();
        const interval = setInterval(getData, 5000);
        return () => clearInterval(interval);
    }, []);

    // Função para agrupar dispositivos por tipo
    const agruparPorTipo = (dispositivos) => {
        return dispositivos.reduce((grupos, dispositivo) => {
            const tipo = dispositivo.tipo || "Desconhecido"; // Define um tipo padrão
            if (!grupos[tipo]) grupos[tipo] = [];
            grupos[tipo].push(dispositivo);
            return grupos;
        }, {});
    };

    const dispositivosPorTipo = agruparPorTipo(dispositivos);

    return (
        <div className="dispositivosContainer">
            {Object.entries(dispositivosPorTipo).map(([tipo, dispositivos]) => (
                <div key={tipo} className="dispositivosGrupo">
                    <h2>{tipo}</h2>
                    <div className="dispositivosCentral">
                        {dispositivos.map((dispositivo, index) => (
                            <div key={index} className="dispositivosModal">
                                <h3>{dispositivo.nome}</h3>
                                <h4>{dispositivo.ip}</h4>
                                <p>Tipo: {dispositivo.tipo}</p>
                                <p
                                    className={
                                        dispositivo.status ? "ativo" : "inativo"
                                    }
                                >
                                    Status: {dispositivo.status
                                        ? "Ativo"
                                        : "Inativo"}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}
